module.exports = __webpack_public_path__ + "img/empty-cart.f21064b.png";